import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from "axios"
import i18n from '../../i18n'
import './FollowerListDialog.scss'

import { Dialog } from "@material-ui/core";
import Icon from '@material-ui/icons/Search'

const TABS = {
    Follower: 'FOLLOWER',
    Following: 'FOLLOWING',
}

class FollowerListDialog extends Component {

    state = {
        curTab: TABS.Follower
    }

    isEndedScroll = false
    scrollViewRtf = null

    componentDidMount() {
        
    }
    
    componentWillUnmount() {
        window.document.body.removeEventListener('scroll', this.onBodyScroll)
    }

    handleClickTabBtn = (tabType) => {
        const { getFollowers, getFollowings } = this.props

        if(this.scrollViewRtf) this.scrollViewRtf.scrollTo({ top: 0 })
        this.setState({ curTab: tabType })

        getFollowers(true)
        getFollowings(true)
    }
    
    onScrollItemContainer = (e) => {
        const { curTab } = this.state
        const { getFollowers, getFollowings } = this.props
        if(e.target.childElementCount === 0) return
        const lastChild = e.target.lastElementChild
        const lastChildStyle = window.getComputedStyle(lastChild)
        const lastChildRect = lastChild.getClientRects()[0]
        const scrollViewRect = e.target.getClientRects()[0] 

        const lastChildMarginBottom = Number(lastChildStyle.marginBottom.replace('px', ''))
        if((lastChildRect.bottom + lastChildMarginBottom - 2) <= scrollViewRect.bottom) {
            if(!this.isEndedScroll) {
                if(curTab === TABS.Follower) {
                    getFollowers()
                }
                else {
                    getFollowings()
                }
                this.isEndedScroll = true;
            }
        }
        else {
            this.isEndedScroll = false;
        }
    }

    render() {
        const {
            curTab,
        } = this.state
        const { 
            open, 
            classes, 
            followingList,
            followerList, 
            followingCount,
            followerCount,
            onClickCloseDialog, 
            onClickFollowBtn, 
            onClickUserProfile,
            currentUser
        } = this.props

        const iconFollow = 'https://front.videomonster.com/images-7cuytg20/web/newgallery/userFollowBefore.svg'
        const iconFollowing = 'https://front.videomonster.com/images-7cuytg20/web/followingIcon.svg'
        const curList = (curTab === TABS.Follower) ? followerList : followingList

        return (
            <Dialog fullWidth={this.props.fullWidth} maxWidth={"lg"} open={open} onClose={onClickCloseDialog}>
                <div className="followerList-main-container">
                    <div className="followerList-title-container">
                        <div>{i18n.t("global.follow")}</div>
                    </div>
                    <div className="followerList-tap-container">
                        <div className={"tab-btn" + (curTab === TABS.Follower ? " selected" : "")} onClick={() => { this.handleClickTabBtn(TABS.Follower) }}>
                            <div>{followerCount}</div>
                            <div>{i18n.t("global.follower")}</div>
                        </div>
                        <div className={"tab-btn" + (curTab === TABS.Following ? " selected" : "")} onClick={() => { this.handleClickTabBtn(TABS.Following) }}>
                            <div>{followingCount}</div>
                            <div>{i18n.t("global.following")}</div>
                        </div>
                    </div>
                    <div ref={ref => { this.scrollViewRtf = ref; }} className="followerList-userinfo-container scroll-hide" onScroll={(e) => { this.onScrollItemContainer(e) }}>
                        {
                            curList.length > 0 && curList.map(info => {
                                const porfileURL = info.profileURL ? info.profileURL : "https://front.videomonster.com/images-7cuytg20/common/v2-profile.svg"
                                const isMine = currentUser ? currentUser._id === info.userId : false
                                return (
                                    <div className="followerList-userinfo-item">
                                        <img src={porfileURL} alt={'icon-profile'} onClick={() => { onClickUserProfile(info) }} />
                                        <div onClick={() => { onClickUserProfile(info) }}>{info.displayName}</div>

                                        {
                                            !isMine ? <img
                                                src={info.isFollowed ? iconFollowing : iconFollow}
                                                alt={'icon-follow'}
                                                onClick={() => { onClickFollowBtn(info, curTab) }}
                                            />
                                            :
                                            <div style={{ width: 40, height: 40 }} />
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang,
    currentUser: state.userStore.user,
})

export default connect(mapStateToProps, null)(FollowerListDialog)